import styled from 'styled-components';

export const StyledFooterSection = styled('div')<{ isCollapsed: boolean }>`
  display: flex;
`;
